<ngb-alert *ngIf="alert"
           [type]="alert?.type"
           (close)="close()">{{alert.message}}</ngb-alert>
